<template>
  <div v-show="homeScreenStatus" class="home">
    <Subject name="math" />
    <div id="background-home"></div>
    <div class="banner">
      <div class="banner__title">Pet Life</div>
      <div class="banner__subtitle">Two Digit Sums</div>
      <div id="cat-home"></div>
    </div>
    <button class="start" @click="clickStart">Start</button>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import { Howl } from 'howler';
import lottie from 'lottie-web/build/player/lottie';
import sounds from '@/packages/sounds/index.js';

export default {
  name: 'Home',
  components: {
    Subject: () => import('@/components/practices/Subject.vue'),
  },
  computed: {
    ...mapGetters({
      homeScreenStatus: 'petLife/homeScreenStatus',
    }),
  },
  mounted() {
    const backgroundHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('background-home'),
      renderer: 'svg',
      loop: false,
      path: '/assets/practices/pet_life/animations/pet_life_background.json',
      rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
      },
    });
    const catHomeAnimation = lottie.loadAnimation({
      container: document.getElementById('cat-home'),
      renderer: 'svg',
      loop: true,
      path: '/assets/practices/pet_life/animations/pet_life_cat_white.json',
    });
    backgroundHomeAnimation.play();
    catHomeAnimation.play();
    sounds.petLifeCatWhite.play();
  },
  methods: {
    ...mapActions({
      homeClickStart: 'petLife/homeClickStart',
    }),
    clickStart() {
      sounds.globalButton.play();
      this.homeClickStart();
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';

.home {
  @include flex-center;
  height: 100vh;
  position: absolute;
  width: 100vw;
  background-color: #73b8e0;
}

.banner {
  @include flex-center;
  background-color: #00000099;
  color: $pet-life-color-main;
  flex-direction: column;
  height: 35vh;
  position: absolute;
  width: 100vw;
  z-index: 1;

  &__title {
    font-family: 'Minecrafter', sans-serif;
    font-size: 3em;
  }

  &__subtitle {
    font-family: 'RimouskiSb-Regular', sans-serif;
    font-size: 1.75em;
  }
}

button {
  background-color: $pet-life-color-main;
  border: none;
  border-radius: 50vh;
  font-family: 'VCR OSD Mono', sans-serif;
  font-size: 1.5em;
  padding: 0.05em 0.75em;
  position: absolute;
  transform: translate(0, 25vh);
  z-index: 1;
}

#background-home,
#cat-home {
  position: absolute;
}

#background-home {
  height: 100vh;
  width: 100vw;
}

#cat-home {
  bottom: 0;
  height: 20vh;
  right: 5vw;
  width: calc(20vh * 1.65);
  z-index: 1;
}

@media (max-aspect-ratio: 8/5) {
  #cat-home {
    height: 15vh;
    right: 2.5vw;
    width: calc(15vh * 1.65);
  }
}
</style>
